<script setup lang="ts">
defineProps<{
  modelValue: boolean;
  isLoading: boolean;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
  confirm: [];
}>();

function close() {
  emit('update:modelValue', false);
}
</script>

<template>
  <v-dialog
    :model-value="modelValue"
    max-width="440"
    :persistent="isLoading"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <v-card>
      <v-card-title class="text-h6">Withdraw commitment</v-card-title>
      <v-card-text>
        <p class="text-body-2">
          Are you sure you want to withdraw? You will lose your commitment, but
          you won't be charged. You can commit again if spots are still
          available.
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" :disabled="isLoading" @click="close">
          Cancel
        </v-btn>
        <v-btn
          color="error"
          variant="flat"
          :loading="isLoading"
          @click="emit('confirm')"
        >
          Withdraw
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
